<template>
  <div class="flex h-full flex-row">
    <div class="flex flex-shrink-0 flex-col gap-y-4 print:hidden">
      <TheNewInvoicingNav />
    </div>
    <div class="mx-2 flex min-w-0 flex-1 flex-col gap-y-3">
      <div class="min-h-0 flex-1">
        <DashboardMainContainer :type-dashboard="['commission_note']" />
      </div>
    </div>
  </div>
</template>

<script>
import DashboardMainContainer from '@c/Dashboard/DashboardMainContainer.vue'
import TheNewInvoicingNav from '@/views/invoicing/components/TheNewInvoicingNav.vue'

export default {
  name: 'TheCommissionNoteIndexPage',
  components: {
    TheNewInvoicingNav,
    DashboardMainContainer
  }
}
</script>
